import React from "react";
import { Logo } from "assets/svg";
import { Link } from "react-router-dom";

const ResetPasswordSuccessAdminPage = () => {
  return (
    <main className="bg--blur box">
      <div
        className="w-full rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <Logo
          className="flex justify-center items-center w-[200px] h-[81px] aspect-[1/1] mb-[30px]
             sm:w-[300px] sm:h-[121px] sm:mb-[40px]"
        />
        <h2
          className="text-[22px] text-center not-italic font-bold text-primary mb-[15px]
        sm:text-[28px]"
        >
          パスワードの <br />
          再設定が完了しました
        </h2>
        <p className="text-[15px] font-normal leading-[160%] text-center mb-[30px] sm:text-[16px]">
          新しいパスワードが正常に登録されました。
          <br />
          ログイン画面から、再設定したパスワードで <br />
          ログインしてください。
        </p>

        <div className="text-[12px] text-center w-full sm:text-[13px] sm:mb-[40px]">
          ※ログインできない場合は再度パスワードリセットをお試しください。
        </div>

        <Link
          to="/admin"
          className=" text-center w-full bg-primary text-white py-2 rounded-[6px] mb-[15px] sm:max-w-[340px] sm:text-[18px] "
        >
          ログイン
        </Link>
      </div>
    </main>
  );
};

export default ResetPasswordSuccessAdminPage;
